import { AUTO_ANNOTATION_NONPRODUCTIONDATAFLOW_TYPE } from "../../../utils/artefacts";
import {Modal} from "antd";
import FileSaver from "file-saver";

export const NODE_CONFIGURATION_KEY_DDB = "ddbDataflow";
export const NODE_CONFIGURATION_KEY_LINKED = "linkedDataflowNode";
export const NODE_CONFIGURATION_KEY_VIRTUAL = "dataflowCatalogType";



export function dataflowIsNotProduction(dataflow) { 

    let isNotProductionDataflow = false;
    const notProductionAnnotation =   [...(dataflow.annotations || []), ...(dataflow.autoAnnotations || [])]
    .find((ann) => (ann && ((ann.type || "").toLowerCase() === AUTO_ANNOTATION_NONPRODUCTIONDATAFLOW_TYPE.toLowerCase())));
    
    if (notProductionAnnotation) {
      const text = notProductionAnnotation.text;
      if (text && text["en"]) {
          isNotProductionDataflow = true;
      }
    }

    return isNotProductionDataflow;
}


export function isDataFlowReadOnly(dataflow, annotationsConf) {
    return dataflow.autoAnnotations && annotationsConf? 
                !!dataflow.autoAnnotations.find((ann) => 
                     ann && annotationsConf && (ann.type === annotationsConf[NODE_CONFIGURATION_KEY_DDB].type ||
                                                ann.type === annotationsConf[NODE_CONFIGURATION_KEY_LINKED].type ||  
                                                ann.type === annotationsConf[NODE_CONFIGURATION_KEY_VIRTUAL].type)) ||
                                                !isDataFlowNotInProduction(dataflow) : false;
}

export function isDataFlowReadOnlyColorIcon(dataflow, annotationsConf) {
    return dataflow.autoAnnotations && annotationsConf? 
                !!dataflow.autoAnnotations.find((ann) => 
                     ann && annotationsConf && (ann.type === annotationsConf[NODE_CONFIGURATION_KEY_DDB].type ||
                                                ann.type === annotationsConf[NODE_CONFIGURATION_KEY_LINKED].type ||  
                                                ann.type === annotationsConf[NODE_CONFIGURATION_KEY_VIRTUAL].type)) : false;
}

export function isDataFlowNotInProduction(dataflow) {
    return dataflow.autoAnnotations ? !!dataflow.autoAnnotations.find((ann) => ann && ann.type === "NonProductionDataflow") : false;
}

export function isDataFlowHasMappingSets(dataflow) {
    return dataflow.categories ? !!dataflow.categories.length > 0 : false;
}

export function isNotNormalDataflow(dataflow, annotationsConf, t) {
    let textExtended = "";
    if (dataflow.autoAnnotations && annotationsConf) {
        if (dataflow.autoAnnotations.find(x => x.type === annotationsConf[NODE_CONFIGURATION_KEY_DDB].type)) {
            textExtended = ` (${t('scenes.mappingHandler.MappingSet.createDataflowBuilder')})`;
        } else if (dataflow.autoAnnotations.find(x => x.type === annotationsConf[NODE_CONFIGURATION_KEY_LINKED].type)) {
            textExtended = ` (${t('scenes.mappingHandler.MappingSet.linkedDataflowNode')})`;
        } else if (dataflow.autoAnnotations.find(x => x.type === annotationsConf[NODE_CONFIGURATION_KEY_VIRTUAL].type)) {
            textExtended = ` (${t('scenes.mappingHandler.MappingSet.virtualDataflow')})`;
        } else if (!dataflow.autoAnnotations.find(x => x.type === 'NonProductionDataflow')) {
            textExtended = ` (${t('data.dataflow.isProduction.values.true')})`;
        }
        
    }
    return textExtended;
}


export function downloadCSVFile(dataTable, dsdColumnName) {
    const headers = Object.keys(dataTable[0]).filter(key => key !== "key");
    const csvHeader = headers.map(item => item !== "Component" ? `Column ${item}` : `Component ${dsdColumnName}`);
    const csvHeaderString = `${csvHeader.join(";")}\n`;
    const rowsString = dataTable.map(row => headers.map(header => header !== "Component" ? row[header] : row[header] ? row[header].Code : null).join(";")).join("\n");

    const csvName = headers.map(item => item !== "Component" ? item : dsdColumnName).join("_");
    const file = new File([csvHeaderString+rowsString], `${csvName}.csv`, {type: "text/csv;charset=utf-8"});
    FileSaver.saveAs(file, `${csvName}.csv`);
}  

export function handleFileUpload(event) {
    if (event) {
        return new Promise((resolve, reject) => {
            const file = event;
            let convertedHeader = [];
            let convertedBody = [];
            let csvData = [];


            const reader = new FileReader();
            reader.onload = (e) => {
                let content = e.target.result;
                content = content.replaceAll('"', '');

                const lines = content.split('\n');
                const data = [];
                for (let i = 0; i < lines.length; i++) {
                    const row = lines[i].split(';');
                    data.push(row);
                }
                const headers = data[0];
                const body = data.slice(1);
                convertedHeader = convertHeader(headers);
                convertedBody = convertBodyToArrayOfObject(body, headers);
                csvData = convertedBody;
                csvData.unshift(convertedHeader);

                resolve(csvData);
            };
            reader.readAsText(file);
            }
        );
    }
}



export function convertHeaderToObject(arr, key) {
    const newArr = [];
    arr.forEach((element) => {
        if(element.includes("Column ")) element = element.replace("Column ","");
        if(element.includes("Component ")) element = element.replace("Component ","");
        let obj = {};
        obj[key] = element;
        newArr.push(obj);
    });
    return newArr;
}

export function convertHeader(arr) {
    const newArr = [];
    arr.forEach((element) => {
        if(element.includes("Column ")) element = element.replace("Column ","");
        if(element.includes("Component ")) element = element.replace("Component ","");
        newArr.push(element);
    });
    return newArr;
}

export function convertBodyToArrayOfObject(arr, keys) {
    const newArr = [];
    arr.forEach((elements) => {
        let obj = {};
        keys.forEach((key, index) => {
            if(key.includes("Column ")) key = key.replace("Column ","");
            if(key.includes("Component ")) key = key.replace("Component ","");

            obj[key] = elements[index];
        })
        newArr.push(obj);
    })
    return newArr;
}

export function checkImportedCSV(dataTable, csvData, columnCodelist, componentName, t) {
    const headersDataTable = Object.keys(dataTable[0]).filter(key => key !== "key");
    const headersCSV = csvData[0];
    const bodyCSV = csvData.slice(1);

    headersDataTable[headersDataTable.length - 1] = componentName;

    if (headersCSV.length !== headersDataTable.length) {
        Modal.warning({
            title: t('scenes.mappingHandler.MappingSet.transcoding.error.csvImportedTitle'),
            content: t('scenes.mappingHandler.MappingSet.transcoding.error.csvNumberOfColums')
        });
        return dataTable;
    } 

    for (let i = 0; i < headersDataTable.length; i++) {
        
        if (headersDataTable[i] !== headersCSV[i]) {
            Modal.warning({
                title: t('scenes.mappingHandler.MappingSet.transcoding.error.csvImportedTitle'),
                content: t('scenes.mappingHandler.MappingSet.transcoding.error.csvNameOfColums')
            });
            return dataTable;
        }
    }

    for (let k = 0; k < bodyCSV.length; k++) {
        let check = true;
   
        for (let idx = 0; idx < Object.keys(bodyCSV[k]).length - 1; idx++) {
            const key = Object.keys(bodyCSV[k])[idx];
            check = check && bodyCSV[k] && dataTable[k] && bodyCSV[k][key] === dataTable[k][key];
        }

        if (check) {
            dataTable[k].Component = columnCodelist.find(el => bodyCSV[k][componentName] === el.Code)
        } 
    }

    return dataTable;
}

